import { useState } from "react"
import Collapse from "@mui/material/Collapse"
import Icon from "@mui/material/Icon"
import Grid from "@mui/material/Grid"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import MDInput from "components/MDInput"
import MDSelect from "components/MDSelect"
import MDTypography from "components/MDTypography"

const STATUS_TABS = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "all", label: "All" },
]

const RuleListFilters = ({
  search = "",
  onSearchChange,
  filters,
  onChange,
  entityOptions,
  categoryOptions,
  regionOptions,
  activeCount = 0,
  status = "active",
  onStatusChange,
  onCreate,
}) => {
  const [open, setOpen] = useState(false)

  // Full width again from lg up: that is where this panel lives in the narrow
  // rules sidebar, where three selects side by side would be unusable.
  const filterSelect = (label, key, options) => (
    <Grid item xs={12} sm={4} lg={12}>
      <MDSelect
        isClearable
        labelType="non-sticky"
        labelText={label}
        placeholder="All"
        options={options}
        value={options.find((o) => o.value === filters[key]) || null}
        onChange={(o) => onChange({ ...filters, [key]: o?.value || "" })}
      />
    </Grid>
  )

  const hasFilters = activeCount > 0

  return (
    <MDBox mb={2}>
      <MDBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
        <MDBox sx={{ flex: "1 1 120px", minWidth: 0 }}>
          <MDInput
            fullWidth
            value={search}
            placeholder="Search rules…"
            onChange={(e) => onSearchChange?.(e.target.value)}
            startAdornment={
              <Icon fontSize="small" sx={{ color: "text.secondary", mr: 0.5 }}>
                search
              </Icon>
            }
          />
        </MDBox>
        <MDButton
          variant={open || hasFilters ? "contained" : "outlined"}
          color="info"
          size="medium"
          onClick={() => setOpen((v) => !v)}
          sx={{ flexShrink: 0 }}
        >
          <Icon sx={{ mr: 0.5 }}>filter_list</Icon>
          Filter
          {hasFilters && (
            <MDBox
              component="span"
              ml={0.75}
              px={0.75}
              borderRadius="md"
              bgColor="white"
              color="info"
              sx={{ fontSize: 12, fontWeight: 700, lineHeight: 1.6 }}
            >
              {activeCount}
            </MDBox>
          )}
        </MDButton>
        {onCreate && (
          <MDButton
            variant="gradient"
            color="info"
            size="medium"
            iconOnly
            onClick={onCreate}
            sx={{ flexShrink: 0 }}
          >
            <Icon>add</Icon>
          </MDButton>
        )}
      </MDBox>

      <MDBox display="flex" gap={0.75} mt={1}>
        {STATUS_TABS.map((tab) => (
          <MDButton
            key={tab.value}
            size="small"
            variant={status === tab.value ? "gradient" : "outlined"}
            color="info"
            onClick={() => onStatusChange?.(tab.value)}
          >
            {tab.label}
          </MDButton>
        ))}
      </MDBox>

      <Collapse in={open}>
        <MDBox
          mt={1.5}
          px={2}
          py={2}
          borderRadius="lg"
          bgColor="grey-100"
        >
          <MDTypography variant="caption" color="text" display="block" mb={1.5}>
            Narrow the rules list — these filters do not change the rule being
            edited.
          </MDTypography>
          <Grid container spacing={1.5}>
            {filterSelect("Applies to", "entity", entityOptions)}
            {filterSelect("Category", "category", categoryOptions)}
            {filterSelect("Region", "region", regionOptions)}
          </Grid>
          {hasFilters && (
            <MDButton
              size="small"
              variant="text"
              color="info"
              sx={{ mt: 1 }}
              onClick={() => onChange({ entity: "", category: "", region: "" })}
            >
              Clear filters
            </MDButton>
          )}
        </MDBox>
      </Collapse>
    </MDBox>
  )
}

export default RuleListFilters
